// Property types the ingestion buy-box gate understands. Intentionally omits
// 'portfolio' — that's a buyer-matching synthetic type, not an inbound filter.
export const BUYBOX_PROPERTY_TYPES = [
    { key: 'single_family', label: 'Single Family' },
    { key: 'multi_family',  label: 'Multi-Family'  },
    { key: 'townhouse',     label: 'Townhouse'      },
    { key: 'condo',         label: 'Condo'          },
    { key: 'mobile',        label: 'Mobile'         },
    { key: 'land',          label: 'Land'           },
];

// 2-letter codes only — evaluateGeography silently drops anything that isn't a
// 2-char code, so pickers must emit codes, never full state names.
export const US_STATE_CODES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
    'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
    'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
    'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
    'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC',
];

// null when empty/unparseable; saved shape must match the buyer pipeline numeric fields.
export const parseBuyBoxNum = (val) => {
    const str = String(val ?? '');
    if (str.trim() === '') return null;
    const cleaned = str.replace(/[^0-9.]/g, '');
    if (cleaned === '') return null;
    const num = parseFloat(cleaned);
    return Number.isFinite(num) ? num : null;
};

const _fmt = new Intl.NumberFormat('en-US');

export const formatThousands = (val) => {
    const digits = String(val ?? '').replace(/\D/g, '');
    if (!digits) return '';
    return _fmt.format(parseInt(digits, 10));
};

// Digit-only input sanitizer (e.g. bedrooms).
export const sanitizeInt = (val) => String(val ?? '').replace(/\D/g, '');

// Decimal input sanitizer (e.g. bathrooms: "2.5"). Strips all non-numeric chars
// except the first decimal point.
export const sanitizeDecimal = (val) => String(val ?? '').replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');

// Year built input sanitizer — digits only, capped at 4 characters.
export const sanitizeYear = (val) => String(val ?? '').replace(/\D/g, '').slice(0, 4);

// Chip label for a numeric range: returns "N–M{unit}", "N+{unit}", "Up to M{unit}", or null.
export const rangeChip = (min, max, unit) => {
    if (min != null && max != null) return `${min}–${max}${unit}`;
    if (min != null) return `${min}+${unit}`;
    if (max != null) return `Up to ${max}${unit}`;
    return null;
};

// Short money label for chips: 250000 → "$250k", 1500000 → "$1.5M", 1000000 → "$1M".
export const shortMoney = (n) => {
    if (!Number.isFinite(n)) return '';
    if (n >= 1000000) return `$${Number((n / 1000000).toFixed(1)).toString()}M`;
    if (n >= 1000) return `$${Math.round(n / 1000)}k`;
    return `$${n}`;
};
